import { fetchWithAuth } from "./fetchWithAuth";

export async function uploadEmailMedia(apiUrl, file) {
  const fd = new FormData();
  fd.append("file", file);

  const res = await fetchWithAuth(`${apiUrl}/api/admin/emails/upload`, {
    method: "POST",
    body: fd,
  });

  if (!res.ok) {
    const e = await res.json().catch(() => ({}));
    throw new Error(e.message || "Upload failed");
  }

  const data = await res.json();
  if (!data?.url) throw new Error("Upload failed: missing url");
  return data.url;
}